<vl-region v-if="isMounted">
    <vl-layout>
        <vl-form-grid mod-stacked>
            <!-- error -->
            <vl-column v-if="isError">
                <vl-alert icon="alert-circle" title="Uw planaanvraag kon niet verwerkt worden" mod-error>
                    <template v-if="errorMessages">
                        <ul v-if="errorMessages.length > 1">
                            <li v-for="(message, index) in errorMessages" :key="index">
                                {{ message }}
                            </li>
                        </ul>
                        <p v-else>{{ errorMessages[0] }}</p>
                    </template>
                </vl-alert>
            </vl-column>
            <!-- ./error -->

            <vl-column>
                <vl-title tag-name="h2">Zone intekenen</vl-title>
                <vl-typography>
                    <p v-if="!usePhoneMode">Teken of importeer de zone waarin de werken zullen plaatsvinden.</p>
                    <p v-else>Teken de zone waarin de werken zullen plaatsvinden. Sluit de zone door te dubbelklikken.</p>
                </vl-typography>
            </vl-column>
            <vl-column>
                <kl-draw-zone-map
                    v-show="showMap"
                    :show-map="showMap"
                    :mod-disabled="isSending"
                    name="zone"
                    ref="drawZoneMap"
                    :input-geometries="zones"
                    :rules="mapRules"
                    :reference="reference"
                    :include-imkl="includeImkl"
                    :for-maprequest="true"
                    @input="onZonesChanged"
                    @zone-price="onZonePrice"
                    mod-maprequest-zone

                    :auto-start-create-state="usePhoneMode"
                    :auto-edit-after-create="usePhoneMode"
                    :auto-confirm-after-each-edit="usePhoneMode"
                    :mod-enable-multi-zones="!usePhoneMode"
                    :sidebar-at-bottom="usePhoneMode"
                    :zone-is-always-selected="usePhoneMode"
                    :show-delete-action="usePhoneMode"
                    :show-import-action="false"
                    :mod-show-gps-location-button="usePhoneMode"
                />
            </vl-column>
        </vl-form-grid>
        <vl-u-spacer mod-large />
        <vl-button @click="onSubmit" :mod-loading="isSending" :mod-disabled="isSending || !isValid" mod-large>
            {{ saveButtonLabel }}
        </vl-button>
    </vl-layout>
</vl-region>
